import _ from 'lodash'

export const activeGroupIdSelector = (state) => state.getIn(['ui', 'groupStack', 'activeGroup'])
export const groupMembersSelector = (state, groupId) =>
    state.getIn(['ui', 'entityStack', 'groups', 'groups']).find((group) => _.toString(group.get('id')) === groupId)
